<template>
<transition name="slide-fade" >
    <div class="modal-sheet" v-if="opened" >

        <div class="sheet bg-00dp">
            <div class="head" v-if="title">
                <h1>{{title}}</h1>
                <div class="btn " @click="hide"><i class="icon icon-sm icon-close invert"></i></div>
            </div>

            <div class="content">
                <slot></slot>
            </div>
            <div class="foot">
                <slot name="footer"></slot>
            </div>
        </div>

        <div class="backdrop" @click="closeBackdrop"></div>

    </div>
</transition>
</template>

<script>
import Navbar from '@/components/layout/Navbar'
export default {
    name: "Modal",
    components: {Navbar},
    props: { 
        title: '', 
        closeOnBackdrop:{
            default: true
        }
    },
    data(){
        return {
            opened: false,
            animate: false
        }
    },
    methods:{
        show(){
            this.opened = true
            // const component = this.$mount();
		    // document.querySelector('body').appendChild(component.$el)
        },
        hide(){
            this.opened = false
        },
        closeBackdrop(){
            if(this.closeOnBackdrop){
                this.hide()
            }
            this.$emit('cancelled')
        }
    }
};
</script>

<style scoped>

.modal-sheet {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    z-index: 1030;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
}
.sheet{
    max-width: 400px;
    min-height: 200px;
    max-height: 80%;
    width: 100%;
    z-index:1300;
    box-shadow: 0 1px 2px -2px rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 4%), 0 2px 5px 0 rgb(0 0 0 / 6%), 0 0 0 1px rgb(0 0 0 / 3%);
    border-radius: 0.25rem;
}

.sheet .head{
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
}
.sheet .head h1{
	font-size: 16px;
	font-weight: 600;
}
.sheet .head .btn{
	font-size: 18px;
}
.sheet .content{
    padding: 12px;
    overflow: auto;
    /* height: calc( 100vh - 150px); */
    flex-grow: 1;
}

.sheet .foot{
    padding: 8px 12px;
}



.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .3s ;
  /* transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
}
.slide-fade-enter, .slide-fade-leave-to{
  transform: translateY(30px);
  opacity: 0;
}

.backdrop {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh; 
    background-color: #00000060;
    opacity: 1;
    /* -webkit-backdrop-filter: blur(1.5px);
    backdrop-filter: blur(1.5px); */
    -webkit-transition: all .1s ease-in-out;
	-moz-transition: all .1s ease-in-out;
	-o-transition: all .1s ease-in-out;
	transition: all .1s ease-in-out;
}


.content::-webkit-scrollbar,
.content::-webkit-scrollbar-thumb{
	display: none;
}


</style>
